const zh = {

    // 菜单
    "menu": [
            {
                id: "1",
                "name": '首页',
            },
            {
                id: "2",
                "name": '专业服务',
                "subName": [
                    {
                        id: "2-1",
                        name: "仓储" 
                    },{
                        id: "2-2",
                        name: "多样化运输方案"
                    },
                    {
                        id: "2-3",
                        name: "国际货代"
                    },
                    {
                        id: "2-4",
                        name: "增值服务"
                    },{
                        id: "2-5",
                        name: "化学供应链解决方案"
                    },{
                        id: "",
                        name: "更多"
                    }
                ]
            },
            {
                id: "3",
                name: '行业解决方案',
                "subName": [
                    {
                        id: "3-1",
                        name: "应用材料"
                    },{ 
                        id: "3-2",
                        name: "油漆涂料"
                    },{
                        id: "3-3",
                        name: "润滑油"
                    },{
                        id: "3-4",
                        name: "农化"
                    },{
                        id: "3-5",
                        name: "电子化学"
                    },{
                        id: "3-6",
                        name: "新能源"
                    },{
                        id: "3-7",
                        name: "化学试剂"
                    },{
                        id: "3-8",
                        name: "更多"
                    }
                ]
            },
            {
                id: "4",
                name: '全国网络',
                "subName": [
                    {
                        id: "4-1",
                        name: "华东"
                    },{
                        id: "4-2",
                        name: "华北"
                    },{
                        id: "4-3",
                        name: "西南"
                    }
                    ,{
                        id: "4-4",
                        name: "华南"
                    }
                ]
            },
            {
                id: "5",
                name: '前沿科技',
                'subName': [
                    {
                        id: "5-1",
                        name: "仓储信息可视化"
                    },{
                        id: "5-2",
                        name: "运输远程可视化"
                    },{
                        id: "5-3",
                        name: "HSSEQ 自主开发管理软件"
                    },{
                        id: "5-4",
                        name: "客户端接口"
                    }
                ]
            },
            {
                id: "6",
                name: 'HSSEQ管理体系',
                "subName": [
                    {
                        id: "6-1",
                        name: "HSSEQ体系建设里程碑"
                    },{
                        id: "6-2",
                        name: "目标与宗旨"
                    },{
                        id: "6-3",
                        name: "数智化运用"
                    },{
                        id: "6-4",
                        name: "个性化定制"
                    },{
                        id: "6-5",
                        name: "特色展示"
                    }
                ]
            },
            {
                id: "7",
                name: '关于我们',
                "subName": [
                    {
                        id: "7-1",
                        name: "愿景"
                    },{
                        id: "7-2",
                        name: "资质荣耀"
                    },{
                        id: "7-3",
                        name: "企业社会责任"
                    },{
                        id: "7-4",
                        name: "联系我们"
                    }
                    // ,{
                    //     id: "7-5",
                    //     name: "合作伙伴"
                    // }
                ]
            },
            {
                id: "8",
                name: '新闻中心',
                "subName": [
                    {
                        id: "8-1",
                        name: "公司新闻"
                    },{
                        id: "8-2",
                        name: "KLN动态"
                    }
                    // ,{
                    //     id: "8-3",
                    //     name: "媒体报道"
                    // }
                ]
            },
            {
                id: "9",
                name: 'K-PORTAL'
            }
    ],
    //登录
    "login": {
        "placeholder1": "输入账号",
        "placeholder2": "输入密码",
        "login": "登录"
    },
    "footer": {
        "focus": "关注我们",
        "member": "A member of",
        "company": "嘉顺达化工物流有限公司",
        "link1": "免责声明",
        "link2": "法律声明",
        "link3": "政策",
        "link4": "员工登录",
        "link5": "相关链接",
        "link6": "嘉里物流",
        "link7": "KLN",
        "link8": "嘉顺达蓝海",
        "copyright": "版权所有"
    },
    // 首页
    "index": {
        "title": ["建基亚洲", "服务全球",""],
        "products": {
            "title": "专业服务",
            "actions": [
                {
                    "name": "仓储",
                },{
                    "name": "多样化运输方案",
                },{
                    "name": "国际货代",
                },{
                    "name": "增值服务",
                },{
                    "name": "化学供应链解决方案",
                },{
                    "name": "更多",
                }
            ]
        },
        "industries": {
            "title": "行业解决方案",
            "actions": [
                {
                    "name": "应用材料",
                },{
                    "name": "油漆涂料",
                },{
                    "name": "润滑油",
                },{
                    "name": "农化",
                },{
                    "name": "电子化学",
                },{
                    "name": "新能源",
                },{
                    "name": "化学试剂",
                },{
                    "name": "更多",
                }
            ]
        },
        "about": {
            "title": "您的化工物流专业伙伴",
            "content1": "KLN IMS 物流是 KLN 的重要业务板块之一，集合化工领域综合物流和国际货代两大核心业务提供化学供应链整体解决方案。我们的服务专注于油漆涂料，应用材料，润滑油，农化产品，电子化学品，新能源，化学试剂七大细分领域。我们的制度管理包括基于HSSEQ的全体系认证，在相关领域屡获殊荣，是国内化工物流行业权威组织主要成员。",
            // "content2": "嘉里物流联网是以亚洲为基地的国际第三方物流服务供货商，网络遍及58个国家和地区，并得到跨 越六大洲的货运代理网络支持。 在2020年，我们的全年收入超过68.41亿美元。 我们于全球聘用超过34,000位员工。嘉里物流联网在Armstrong & Associates于2021年发表的环球货运代理及全球海运代理排名中位列第8，并于全球空运代理排名中位列13。",
            "content3": 'KLN',
            "content4": '嘉里物流',
            "more": "了解更多",
            "hideMore": "隐藏更多",
        },
        "globalNet": {
            "title": "全国网络",
            "content": "全国性第三方物流服务供应商，服务网络覆盖超99%城市",
            "net": [
                {
                    "id": 1,
                    "name": "华东",
                    "company": [
                        "上海顺嘉化工有限责任公司",
                        "丰城嘉顺达化工物流有限公司", 
                        "嘉顺达供应链(张家港)有限公司"
                    ]
                },{
                    "id": 2,
                    "name": "华北",
                    "company": [
                        "嘉顺达蓝海(天津)物流有限公司",
                        "嘉顺达化工物流(沧州)有限公司", 
                    ]
                },{
                    "id": 3,
                    "name": "西南",
                    "company": [
                        "嘉顺达呈祥物流(成都)有限公司"
                    ]
                }
                ,{
                    "id": 4,
                    "name": "华南",
                    "company": []
                }
            ],
            "more": "了解更多",
        },

        "technology": {
            "title": "前沿科技",
            "content": "科技创新及应用投入，是我们的长期战略。",
            "content1": "运营管理中的安全，规范与效率都需通过技术创新来实现。",
            "content2": "仓储信息可视化",
            "content3": "运输远程可视化",
            "content4": "HSSEQ 自主开发管理软件",
            // "function": ['全球定位追踪','自主研发App','物流诊断 数据分析','物联网及射频识别技术','供应链控制中心BI','自动存储搬运设施','可穿戴科技语音识别','数据对接平台','全方位物流管理方案'],
            "more": "了解更多"
        },

        "security": {
            "title": "HSSEQ管理体系",
            "content": "我司经过近20年HSSEQ的建设，已经形成完善的管理体系，从国际标准建立摸索到形成符合公司运营特色的质量环境安全管理体系，从最高管理层的战略方针发布到基层的运营作业指导流程，各层管理制度致力于保障客户的服务质量与安全。",
            "more": "了解更多"
        },

        "function": [
            "新闻中心", "加入我们", "员工登录"
        ]
    },
    //专业服务
    "services": {
        "title": "专业服务",
        "function": [
            {
                "name": "仓储",
                "subName": ["普通化学品仓库", "危险化学品仓库", "储罐"]
            },{
                "name": "多样化运输方案",
                "subName": ["国内", "国际", "多式联运"]
            },{
                "name": "国际货代",
                "subName": []
            }
            ,{
                "name": "增值服务",
                "subName": []
            }
            ,{
                "name": "化学供应链解决方案",
                "subName": ["运贸一体服务"]
            }
        ]
    },
    //行业解决方案
    "industries": {
        "title": "行业解决方案",
        "function": [
            {
                "name": "应用材料",
                "subName": []
            },{
                "name": "油漆涂料",
                "subName": []
            },{
                "name": "润滑油",
                "subName": []
            }
            ,{
                "name": "农化",
                "subName": []
            },{
                "name": "电子化学",
                "subName": []
            },{
                "name": "新能源",
                "subName": []
            },{
                "name": "化学试剂",
                "subName": []
            },{
                "name": "更多",
                "subName": []
            }
        ]
    },
    //全国网络
    "globalNet": {
        "title": "全国网络",
        "function": [
            {
                "name": "华东",
                "componey": [{
                    "conpanyName": "上海顺嘉化工有限责任公司",
                    "address1": "上海市浦东新区",
                    "address2": "盛荣路388弄23号",
                    "phone": "021-51386111",
                    "mail": "presiden.office@kerryhcl.com"
                },{
                    "conpanyName": "丰城嘉顺达化工物流有限公司",
                    "address1": "江西省丰城市",
                    "address2": "昌龙江南名居二栋二单元102室",
                    "phone": "0795-6598466",
                    "mail": "presiden.office@kerryhcl.com"
                },{
                    "conpanyName": "嘉顺达供应链(张家港)有限公司",
                    "address1": "江苏省张家港市",
                    "address2": "张家港保税区北京路国际消费品中心大楼308-1166室",
                    "phone": "0512-56720219",
                    "mail": "Hui.Cai@kerryeas.com"
                },{
                    "conpanyName": "嘉会物流(张家港)有限公司",
                    "address1": "江苏省张家港市",
                    "address2": "张家港保税物流园区(东区) 1幢102、103室",
                    "phone": "",
                    "mail": ""
                }]
                
            },{
                "name": "华北",
                "componey": [{
                    "conpanyName": "嘉顺达蓝海(天津)物流有限公司",
                    "address1": "天津市北辰区",
                    "address2": "北辰科技园南区景丽路39号",
                    "phone": "022-86825688",
                    "mail": "wangyihua@lanhai56.cn"
                },{
                    "conpanyName": "嘉顺达化工物流(沧州)有限公司",
                    "address1": "河北省沧州市",
                    "address2": "中捷临港化工园区",
                    "phone": "0317-5837376",
                    "mail": "presiden.office@kerryhcl.com"
                }]
            },{
                "name": "西南",
                "componey": [{
                    "conpanyName": "嘉顺达呈祥物流(成都)有限公司",
                    "address1": "四川省成都市",
                    "address2": "龙泉驿区洪安镇龙洪路9号办公楼2楼",
                    "phone": "028-62046133",
                    "mail": "wangyihua@lanhai56.cn"
                }]
            },{
                "name": "华南",
            }
        ]
    },
    //前沿科技
    "technology": {
        "title": "前沿科技",
        "function": [
            {
                "name": "仓储信息可视化",
                "subName": []
            }, {
                "name": "运输远程可视化",
                "subName": []
            }, {
                "name": "HSSEQ 自主开发管理软件",
                "subName": ["MSDS 云系统", "运输车辆安全检查云系统", "仓库安全例检云管理系统", "NCM (不符合项) 管理云系统", "客户端接口"]
            }
        ]
    },

    //HSSEQ管理体系
    "security": {
        "title": "HSSEQ管理体系",
        "function": [{
            "name": "HSSEQ体系建设里程碑"
        },{
            "name": "目标与宗旨"
        },{
            "name": "数智化运用"
        },{
            "name": "个性化定制"
        },{
            "name": "特色展示"
        }]
    },

    //关于我们
    "about": {
        "title": "关于我们",
        "function": [{
            "name": "愿景"
        },{
            "name": "资质荣耀",
            "subName": ["资质证书","奖励荣耀"]
        },{
            "name": "企业社会责任",
            // "subName": ["环境保护","公益"]
        },{
            "name": "联系我们"
        }
        // ,{
        //     "name": "合作伙伴"
        // }
    ]
    },

    //新闻中心
    "news": {
        "title": "新闻中心",
        "function": [{
            "name": "公司新闻"
        },{
            "name": "KLN动态"
        }
    ]
    },
    // kportal
    "kportal": {
        "title": "K-PORTAL",
        "content1": {
            "title": "客户登录",
            "urls": [{"name":"运输查询","url":"https://hckapp.kerryims.com/T&T/"}, {"name": "数据洞察", "url": "https://insight.kerryims.com/webroot/decision"}]
        },
        "content2": {
            "title": "供应商登录",
            "urls": [{"name":"供应商服务系统","url":"http://118.242.1.226:83/hcwl/vender/Login.aspx"},{"name":"车辆预约系统","url":"https://apps.kerryims.com:82/221/#/dispatcherAdmin-appointment"}]
        },
    },

    //合作伙伴
    "partners": {
        "title": "合作伙伴",
        "function": [{
            "name": "行业伙伴"
        },{
            "name": "供应商"
        }]
    },

    //加入嘉里
    "join": {
        "title": "加入我们",
        "function": [{
            "name": "工作环境"
        },{
            "name": "工作机会"
        }]
    },

    // 员工登录
    "staffLogin": {
        "title": "员工登录",
        "urls": [{
            "title": "市场营销",
            "contents": [{"name": "客户关系管理系统", "url":"https://crm-tencent.xiaoshouyi.com"}]
        },{
            "title": "业务运营",
            "contents": [
                {"name": "TMS运输管理系统", "url":"https://tms.kerryims.com/login"},
                {"name": "运输管理控制台", "url":"https://hckapp.kerryims.com/contower/"},
                {"name": "车辆预约系统", "url":"https://apps.kerryims.com:82/221/#/warehouse/login"},
                {"name": "不符合管理系统", "url":"https://hckapp.kerryims.com/ncm/ncmweb/views/login/login.jsp"},
                {"name": "车辆检查系统", "url":"https://hckapp.kerryims.com/kscweb/login.jsp"},
                {"name": "仓库检查系统", "url":"https://hckapp.kerryims.com/checkweb/index.jsp"},
                {"name": "物料安全信息数字化系统", "url":"https://hckapp.kerryims.com/msds/segments/login/login.jsp"}
            ]
        },{
            "title": "后勤支持",
            "contents": [
                {"name": "云之家", "url":"https://yunzhijia.com/home/saas/jlwl"},
                {"name": "财务管理系统", "url":"https://kerry.kdcloud.com/index.html?&formId=pc_main_console"},
                {"name": "人力资源管理系统", "url":"https://kerry.kdeascloud.com/shr/home.do"},
                {"name": "企业邮箱", "url":"http://mail.kerryims.com/"},
                // {"name": "企业网盘", "url":"http://intranet.kerryims.com:8000/default.aspx"},
                {"name": "企业云盘", "url":"https://shimo.im/loginByPassword?from=home"},
                {"name": "石墨文档", "url":"https://shimo.im/loginByPassword"},
            ]
        },{
            "title": "数据洞察",
            "contents": [{"name": "BI系统", "url":"https://insight.kerryims.com/webroot/decision"}]
        }]
    },

    //组件普通（危险）化学品仓库
    "warehouse1": {
        "content":"按照KLN IMS大化工战略布局，KLN IMS在华北、华东、华南及西部地区积极发展和建设化工物流中心，实现了全国各大区域仓储同步发货。",
        "title1": "普通化学品仓库",
        "title2": "危险化学品仓库"
    },

    //组件储罐
    "warehouse2": {
        "content":"液体储罐区发货平台共60个罐装货位，罐装线总长约270米。可储存中转酮类、醇类、苯类、溶剂油类、烷烃类等危险化学品。"
    },
    //组件多样化运输方案Index
    "diversifiedtransportIndex": {
        "content": "凭借我们的庞大网络，以及KLN的强力支撑，我们可以为客户提供从国内到海外以及多式联运的全链条化工物流解决方案"
    },
    // 组件多样化运输方案
    "diversifiedtransport": [
        {
            "name": "国内",
            "content1": "公路运输、内贸海运、铁路集装箱、铁路专用线",
            "content2": "KLN IMS公路运输网络覆盖全国主要大中城市，为客户提供端对端服务。",
            "content3": "拥有高标准危险品车队，通过CRSAS专业评估。拥有充沛的自有车辆及庞大的外包车队，包括厢型、平板、危险品专用和冷藏保温等多种车型，多数车辆配有GPS装置。",
            "content4": "实现化学品运输防护、应急救援服务、行程可视化平台。",
            "content5": "提供整车、零担、控温、海关监督等多样化公路运输服务。",
            "content6": "甩挂式运输、多式联运等科学的运输模式，持续为客户节约物流成本。",
            // "content7": "我们的",
            "content8": "危险品可运输种类",
            "content9": "第二类：气体",
            "content10": "第三类：易燃液体",
            "content11": "第四类：易燃固体、易于自燃的物质、遇水放出易燃气体的物质",
            "content12": "第五类：氧化性物质和有机过氧化物",
            "content13": "第六类：毒性物质和感染性物质",
            "content14": "第八类：腐蚀性物质",
            "content15": "第九类：杂项危险物质和物品，包括危害环境物质"
        },{
            "content1": "空海运、清关、中欧班列、跨境公路运输",
            "content2": "",
            "title1": "环球货运能力",
            "list1": [
                {
                    "text1": "空海运"
                },
                {
                    "text1": "520,000+",
                    "text2": "每年处理空运量（吨）"
                },
                {
                    "text1": "120万+",
                    "text2": "每年处理海运量(20呎标准货柜)",
                    // "text3": ""
                },
                {
                    "text1": "陆运",
                },
                {
                    "text1": "5,200+",
                    "text2": "每天行驶货车"
                },
                {
                    "text1": "280+",
                    "text2": "亚洲陆路货运站"
                },
                {
                    "text1": "铁运",
                },
                {
                    "text1": "117,000+",
                    "text2": "每年处理货柜量"
                },
                {
                    "text1": "1,900+",
                    "text2": "欧亚铁路货运码头站"
                }
            ],
            "title2": "全方位货运解决方案",
            "list2": {
                "item1": ["整箱及拼箱","买家集运","多式联运","一般/特殊货物","包机","货运总代理/<br>货运服务总代理","报关代理","无船承运"],
                "item2": ["整箱及拼箱","低底盘货车/平板货车","冷冻货车/危险品","保税陆运","项目货物","罐式集装箱","货柜车/无蓬货车","汽车专用运输"],
                "item3": ["整箱及拼箱","包列","多式联运","项目货物","分拨","散装货物","买家集运"]
            }
        },{
            "content1": "2021中欧班列“嘉里号”从成都城厢中心站始发，列车通过阿拉山口口岸出境，驶向欧洲，再经波兰马拉舍维奇后，到达德国杜伊斯堡。此项目是嘉里物流以“一带一路”作为发展纲领的重要进程，也是扩展铁路货运及多式联运服务的策略性举措。",
            "content2": "自2016年起，我们相继在甘肃、宁夏、山西、徐州、成都等地，开行中欧、中亚国际货运班列，年开行国际班列500列+，并为客户提供大宗原料的多式联运，提供集装箱、ISO TANK等多样化设备，涵盖国内江、海、铁低成本物流方案。"
        }
    ],

    //组件国际货代
    "internationalFreight": [
        {
            "content1": "KLN的国际货运解决方案涵盖环球空、海、陆路、铁路及多式联运服务。在 2021 年，KLN处理了超过520,000+吨空运货量，以及120万+个20呎标准货柜海运量。在陆上，KLN每天有5,200+辆货车在路上行驶，并有超过280个亚洲陆路货运站。铁路货运方面，KLN每年处理117,000+个货柜，并有超过1,900个欧亚铁路货运码头站。KLN在处理贸易纠纷、报价、报关和检疫程序方面具丰富经验，更可实时就贸易政策改变及对紧急事宜作出应变，致力于优化客户的国际货运成本效益。",
            "title1": "环球货运能力",
            "list1": [
                {
                    "text1": "空海运"
                },
                {
                    "text1": "520,000+",
                    "text2": "每年处理空运量（吨）"
                },
                {
                    "text1": "120万+",
                    "text2": "每年处理海运量(20呎标准货柜)",
                    // "text3": ""
                },
                {
                    "text1": "陆运",
                },
                {
                    "text1": "5,200+",
                    "text2": "每天行驶货车"
                },
                {
                    "text1": "280+",
                    "text2": "亚洲陆路货运站"
                },
                {
                    "text1": "铁运",
                },
                {
                    "text1": "117,000+",
                    "text2": "每年处理货柜量"
                },
                {
                    "text1": "1,900+",
                    "text2": "欧亚铁路货运码头站"
                }
            ],
            "title2": "全方位货运解决方案",
            "list2": {
                "item1": ["整箱及拼箱","买家集运","多式联运","一般/特殊货物","包机","货运总代理/<br>货运服务总代理","报关代理","无船承运"],
                "item2": ["整箱及拼箱","低底盘货车/<br>平板货车","冷冻货车/<br>危险品","保税陆运","项目货物","罐式集装箱","货柜车/<br>无蓬货车","汽车专用运输"],
                "item3": ["整箱及拼箱","包列","多式联运","项目货物","分拨","散装货物","买家集运"]
            }
        }
    ],

    //组件增值服务
    "valueAdded": {
        "content": "在我们的综合物流解决方案下，我们为客户提供多元化增值服务。通过将分装、限量包装、二次包装、样品管理、调色服务等工序外派给KLN IMS，您可以专注于销售、研发及客户服务等核心业务。",
        "list": [
            {
                "title": "应用材料",
                "content1": "驻场物流及系统",
                "content2": "区域中心",
                "content3": "SCM网络及库存B-b-C",
            },
            {
                "title": "油漆涂料",
                "content1": "驾驶行为",
                "content2": "冬季防冻",
                "content3": "调色服务",
            },
            {
                "title": "润滑油",
                "content1": "丙1类仓库",
                "content2": "分装",
                "content3": "季节性爆量",
            },
            {
                "title": "农化",
                "content1": "限量包装",
                "content2": "道路风险",
                "content3": "EDI",
            },
            {
                "title": "电子化学",
                "content1": "Inbound/VMI",
                "content2": "危险品气体",
                "content3": "序列号管理",
            },
            {
                "title": "新能源",
                "content1": "危险品温控",
                "content2": "Milkrun/逆向物流 ",
                "content3": "包装管理",
            },
            {
                "title": "化学试剂",
                "content1": "二次包装",
                "content2": "样品管理",
                "content3": "MSDS云系统",
            },
        ]
    },

    //组件供应链解决方案
    "supplyChain": {
        "content1": "化学供应链日趋复杂及多面性，为支援您在多国的采购、生产和配送活动，我们提供高度量身订制的解决方案，以满足您的独特需求。",
        "content2": "我们的专业客户管理团队不断为国际客户设计崭新营运模式及解决方案，从咨询、设计以至执行和评估皆兼顾周全，可降低库存、缩短货物推出市场时间。",
        "content3": "通过长期伙伴关系、具竞争力的成本管理，以及持续精益求精，我们致力助你达成在环球、区域及本地的策战略性目标。"
    },

    //组件运贸一体化
    "integrationTransportation": [
        {
            "title": "围绕核心企业的整条供应链，在信用评估及物流监管的基础上，我们面向供应链核心企业及其上下游，提供一整套贸易+物流的解决方案。",
            "year": "年",
            "word1": "煤炭",
            "word2": "钢材",
            "word3": "化工",
            "word4": "建材（砂石、水泥）",
            "ton": "吨"
        }
    ],

    //组件应用材料
    "appliedMaterials": {
        "title1": "On-site",
        "title2": "RDC",
        "content1": "我们依据行业规范制定者的高标准，为国际知名企业的供应链物流合规性保驾护航，为客户提供专业仓储服务，包括普货、危险品，以及保税、保温等特殊需求；从港口、工厂等始发的普货、危险品运输服务；解决客户转仓、用户配送、保税区提送货、逆向物流等覆盖全产业链整体物流的个性化定制方案；更可提供客户现场仓储外包服务。",
        "content2": "提供客户现场的仓储外包服务，包括劳务、系统、库存设计及TCM服务等。",
        "content3": "依靠KLN全球性战略合作体系，我们提供全产业链整体物流解决方案、标准化体系与过程控制。"
    },

    //组件油漆涂料
    "paintCoating": {
        "content1": "我们覆盖全国的运输服务网络拥有具备成本优势的运输路线以及优秀的、具有竞争力的化学危险品营运能力。危险品车辆运输全程具备车辆及货物跟踪系统、GPS、Website 在线跟踪系统等数智化设备。",
        "title1": "即时发货",
        "content2": "7×8小时发货服务, 部分需要7x24的服务；能满足通知时间为1-2小时发货，部分公司提供常驻车辆，有发货协调人常驻。",
        "title2": "增值服务",
        "content3": "换/贴标签，拼板，加固等附加服务。",
        "title3": "危废处理",
        "content4": "回收包装。",
        "title4": "冬季保温运输",
        "content5": "提供有特殊运输温度要求的运输运营方案；满足对车辆车况的特殊要求。"
    },

    //组件润滑油
    "lubricatingOil": {
        "content": "针对润滑油行业特性，我们提供覆盖原料进口、RDC管理、运输、仓储的全链条服务。",
        "title1": "成品、原料进口",
        "content1": "润滑油成品、原料的进口报关、查验以及进口拖车运输等服务。",
        "title2": "国内RDC管理",
        "content2": "针对润滑油产品的特性进行RDC（丙一仓库）的选址、改造及日常管理。",
        "title3": "国内运输",
        "content3": "多式联运、主机厂专车配送、milkrun等日常配送。",
        "title4": "逆向物流",
        "content4": "润滑油产品的逆向运输操作。",
        "title5": "特殊包装容器",
        "content5": "根据客户的不同需求提供多种包装容器方案，FIBC等",
        "title6": "仓配一体信息化",
        "content6": "提供仓库信息可视化，运输配送信息化服务",
        "title7": "卸货服务",
        "content7": "对于收货端需要提供卸货服务的客户，我们随车携带便携式升降设备，在保证卸货效率的同时，保证货物的安全，减少破损的发生。如果批量加大，我们采用尾板车运输，提高卸货效率。",
    },

    //组件农化
    "agrochemical": {
        "content1": "从植保产品、原药供应到作物育种、作物营养，我们为MAP现代农业技术服务商和智慧农业服务平台，提供先进物流解决方案，助力中国农业现代化进程。",
        "title1": "季节性调配",
        "content2": "根据客户需求的季节性特点，我们灵活调配运力，即便在您最忙碌的12月到次年7月，也能确保供应链物流无后顾之忧。",
        "title2": "偏远地区配送",
        "content3": "我们强大的物流网络确保全国各区域中心（RDC）、及偏远地区的配送也能直达。"
    },

    //组件电子化学
    "electronicChemical": {
        "content1": "针对电子化学材料供应链的特殊性，我们提供涵盖化学品气体仓储、标准化运输服务、进口周转容器的管理、专业化学品进口通关及现场作业和咨询的全链条服务。",
        "title1": "化学品气体仓储",
        "content2": "高端仓库结合定制化的改造，包括温控、气体、高规格电子化学品仓储服务。",
        "title2": "标准化运输服务",
        "content3": "针对电子化学品及气体的包装特性，提供专业加固、温控、全程监管等附加服务，并提供路线、速度、温度全程可视化的管理。",
        "title3": "进口周转容器的管理",
        "content4": "包括海关的保证金，瓶号的有效期和追踪，以及出口退运的全链条物流服务。",
        "title4": "专业化学品进口通关",
        "content5": "把控清关流程，提前准备符合专业监管标准的资料，并进行政策宣贯及方案解决。",
        "title5": "现场作业",
        "content6": "提供客户现场的危化品仓储外包服务，包括劳力、系统、库存设计及TCM服务。",
        "title6": "咨询服务",
        "content7": "凭借国内危险品网络及国外各站点资源，为客户提供定制化的咨询服务及供应链解决方案。"
    },

    //组件新能源
    "newEnergy": {
        "content1": "作为新能源汽车动力蓄电池回收利用的绿色供应链上的重要一环，KLN IMS目前在北方地区及东区建立了初具规模的电池回收网点，提供料架管理、危险品运输、逆向物流、网点建设、包装器具等专业服务。当我们接到车企要求提取废旧电池的指令后，即派危险品车前往4S店进行提货；然后安全运往新能源车企指定的废旧回收处理厂家，进行后续动力电池回收、拆解、梯级利用。",
        "title1": "运营模式一",
        "content2": "从新能源电池生产企业提取电池送往各个主机厂；电池料架在新能源电池生产企业和各个主机厂之间的往返物流。",
        "title2": "运营模式二",
        "content3": "从4S门店提取废旧电池，存储在KLN IMS的仓库；货物在KLN IMS仓库存储期间，我们也会为客户提供各项增值服务例如，电池检测、电池放电、重新包装、更换特殊包装配合后续的运输等。",
        "title3": "运营模式三",
        "content4": "应客户的订单，将废旧电池送往新能源电池回收企业。"
    },

    //组件化学试剂
    "chemicalReagent": {
        "content1": "我们覆盖全国的危险品仓库配有甲类危险品仓、恒温与冷冻库，产品涵盖化学、检测、生物试剂，实现华东、华南、华北、华中、西南，全国五大区域仓储同步发货，在23省核心区域科学服务产品“当日达”（2024年时效达成率99%），在缩短物流配送时间的同时，提升产品运送的时效稳定性。"
    },

    //组件HSSEQ体系建设里程碑
    "integrated": {
        "title1": ['ISO9001', 'ISO14001', 'OHSAS18001', 'RSQAS', 'ISO27001' , 'CRSAS','EcoVadis','CWSAS'],
        "title2": ['质量环境安全管理体系的初步形成', '建立并实施了ISO 14001环境管理体系', '建成了以质量管理为基础，环境安全管理为特色的管理体系', '通过道路安全质量评估体系的评审','引入多元化管理体系，全面提升企业管理能力', '通过化学品道路运输安全评估体系的评审','多个公司通过了EcoVadis可持续发展评估体系的银牌认证','所有公司均完成了化学品仓库安全评估体系的评估']
    },

    //组件目标与宗旨
    "institutional": [
        {
            "title": "领导意识、全员参与",
            "content": ['公司管理层积极投入HSSEQ体系管理，将质量环境安全的科学管理作为公司战略目标与宗旨，协调资源，付诸实现。','各级管理人员按照总体战略思想亲身投入，服务与保障本职范围内运营过程体系，确保总体目标实现。','公司全员积极参与过程运行，明确体系建立实施的益处和反之可能产生的不利后果。']
        },
        {
            "title": "文件体系、运营保障",
            "content": ['我司经过近20年HSSEQ管理体系的发展，已经形成较完善的文件制度体系，从依据国际标准摸索建立，到形成符合公司运营特色的质量环境安全管理体系文件架构，从最高管理层的战略方针发布到基层的运营作业指导流程，各层管理制度都在致力于提高每一位客户的服务质量安全。']
        },
        {
            "title": "风险意识、预先管理",
            "content": ['事前预防思维导入各运营过程，在方案制定、流程的策划上辨识出各风险点并加以评价，制定相应措施事前消除不利后果。如通过物流服务方案内部评审、项目操作前评审、重点项目道路风险评估、新供应商引入前评审、首次作业评估等方式，找到隐藏风险，采取相应对策。','通过各种渠道让员工及相关方及时掌握职业健康安全常识、现场应急处置流程、基础危险源辨识知识，提升全员健康安全预防意识。']
        },
        {
            "title": "PDCA、持续优化",
            "content": ['质量环境安全管理体系是公司稳步发展的基本保障，需要在经营过程中结合公司发展战略和目标及服务特色不断进行改进和优化，每个部门、每个项目都需要创新和发展意识。从流程化到标准化再到特色化；从满足客户要求到超越客户需求，永不停歇。']
        }
    ],

    //组件数智化运用
    "responsibilityLanding": [
        {
            "title": "仓检",
            "content": ['以数据化终端的形式，标准化仓储设备硬件、人员行为、管理软件的检查规则，定时、定量的对作业现场的日常巡查、综合检查、隐患排查，进行有效记录，达到提高仓库安全管理，降低安全事故的发生的最终目的。其使用特点为：','杜绝检查过程中的漏项、缺项；','统一检查标准和要求；','体现检查的真实性；','具备可追溯性。']
        },
        {
            "title": "车检",
            "content": ['将车辆设备的预防性检查作为保障设备本质安全的基础，达到保证车辆技术状况的完好、保证行车安全、节约车辆运行综合成本的目的。其使用特点为：','杜绝作业人员的敷衍检查、虚假记录情况发生；','可实时监控检查的状态、结果；','避免纸质记录的统计繁琐、易缺失等缺陷；','保障“一日三检”的真实实施和可追溯性实现。']
        },
        {
            "title": "MSDS",
            "content": ['MSDS（全称Material Safety Data Sheet，俗称化学品安全技术说明书）是化学品生产商和进口商用来阐明化学品的理化特性(如PH值，闪点，易燃度，反应活性等)以及对使用者的健康(如致癌，致畸等)可能产生危害的，具备法律效应的文件。','我们将运营涉及的MSDS汇编成库，以作业性质为界定，根据仓储、运输、应急处置等不同需求，筛选、呈列所需的内容，并以云系统形式提供全员检索，使得各运营阶段、作业阶段、应急阶段等不同对象对MSDS不同字段的需求获取得到实现。']
        },
        {
            "title": "NCM",
            "content": ['NCM-不符合项管理，是全员积极参与质量安全管理的网络数字化工具之一，通过各个岗位人员对于仓储、运输生产以及办公区域活动中发现、发生的不符合项目的及时反馈，能够便捷、清晰、高效的解决问题。','公司尤其鼓励一线员工发现各类隐患，一旦有发生上报，相关人员第一时间收到信息，可以及时处理，包括审批，不受人员地域限制。通过激励机制，鼓励员工多报，养成主动关注质量安全的意识行为。通过后台大数据，分析掌握公司整体质量安全落实情况和发展趋势，找出弱点，及时改进。']
        }
    ],

    //组件个性化定制
    "contingency": [{
        "content": "针对每一个客户项目，根据其性质、操作特点，量身定制相关SOP规则、KPI标准、HSE要求，以点带面的实现“为物流服务保驾护航”。"
    },{
        "content": "将所有化学品运营，都提升到危险化学品经营的高度，自我加压、统一标准，强化管理。"
    },{
        "content": "关注货物“入门关”管理，在化学品入门前，必须先行辨识危害运输，制定并落实存储要点、运输要求、操作流程、环境控制、应急处置等环节，确保整体运营可控。"
    },{
        "content": "有效利用“数智化”软件的节点监控、流程跟踪特点，全程把控整体操作的安全、质量、环境要求实现。"
    }],

    //组件特色展示
    "characteristicDisplay": [{
        "content": "从细节把控全流程畅通，从小处着手带动全面辐射，最终达到整盘标准化实现。"
    },{
        "content": "全员隐患排查参与；"
    },{
        "content": "各点消防布局，微站功能实现。"
    },{
        "content": "实质性的管理人员带队巡检，并记录在案；"
    },{
        "content": "全员责任制的个性化确立，保障“责、薪一体”、“责、权一体”、“岗、能一体”。"
    },{
        "content": "泄漏演习"
    },{
        "content": "消防演习"
    }],

    //组件工作在嘉里
    "work": {
        "content1": "人才是KLN IMS的核心优势。我们透过具前景的事业阶梯、优越的工作环境，以及工作与生活的良好平衡，致力为员工创造价值。",
        "content2": "我们的员工积极进取，凡事全力以赴，并深具企业家精神。我们竭尽所能满足客户所需，提供创新解决方案以助他们实现业务目标。不论是前线员工或是高级管理层，我们集团上下均具备团队精神，并以互重互谅作为合作的基础。",
        "content3": "随着企业不断发展及壮大，我们持续投资于人才培训，透过聘请多元文化背景的业界专才及年轻人才，共建成功团队。"
    },

    //组件集团新闻
    "groupNews": {
        "options": [{
            "label": "2021年",
            "value": "2021"
        },{
            "label": "2020年",
            "value": "2020"
        }],
        "contents": [{
            "title": "2021-01-29 澎湃在线",
            "content1": "张家港：嘉里化工物流中心正式奠基",
            "href": "https://m.thepaper.cn/baijiahao_10984124"
        },{
            "title": "2021-01-08 中国经济网",
            "content1": "嘉里化工沧州物流中心举行开仓仪式，深化化工物流布局促进区域发展",
            "href": "http://www.ce.cn/xwzx/gnsz/gdxw/202101/08/t20210108_36203550.shtml"
        },{
            "title": "2020-11-26 新浪财经",
            "content1": "8个月涨幅近1倍，嘉里物流（00636）再将商业触手伸向了化工物流",
            "href": "https://baijiahao.baidu.com/s?id=1684399993533696034&wfr=spider&for=pc"
        },{
            "title": "2020-11-20 中国经济网",
            "content1": "嘉里物流收购天津蓝海51%股权，加速化工物流领域布局",
            "href": "http://www.ce.cn/xwzx/gnsz/gdxw/202011/20/t20201120_36032888.shtml"
        },{
            "title": "2020-08-19 搜狐新闻",
            "content1": "嘉里化工物流举行战略发布会 深入化工领域布局",
            "href": "https://www.sohu.com/a/413826261_162522"
        },
        {
            "title": "2022-10-25",
            "content1": "【MEDIPARK创新服务平台】嘉里化工物流：为化学供应链物流保驾护航",
            "href": "https://mp.weixin.qq.com/s/rz5BWo_BGGd0r5uIKeYbaQ"
        },{
            "title": "2022-08-18",
            "content1": "嘉里化工物流官方宣传片正式发布",
            "href": "https://mp.weixin.qq.com/s/rlDr4rs3wtHUvK7FKOd33w"
        },{
            "title": "2022-08-09",
            "content1": "郑在常务副理事长兼秘书长率队走访调研嘉里化工物流，聚焦上海国际航运中心建设提质升级",
            "href": "https://mp.weixin.qq.com/s/NXQtuRyXWRtFZe2pC_eqcg"
        },{
            "title": "2022-08-04",
            "content1": "战高温 保安全 | 嘉里化工夏季高温安全生产专项行动",
            "href": "https://mp.weixin.qq.com/s/h7Llov3usm14f9wWwnqAFg"
        },{
            "title": "2022-06-02 罗戈网",
            "content1": "嘉里的化工物流这么强？！ 顺丰又多了一张优势底牌！",
            "href": "https://mp.weixin.qq.com/s?__biz=MjM5NjAzMjM4MA%3D%3D&mid=2651193450&idx=1&sn=5aada097b2e6813af06247a2820e466a&scene=45#wechat_redirect"
        },{
            "title": "2022-05-18",
            "content1": "张家港化工物流项目正式运营 嘉里物流化工赛道布局持续深化",
            "href": "https://mp.weixin.qq.com/s/_7QD8oxixlVPK6LGWCwkbg"
        },{
            "title": "2022-05-16",
            "content1": "嘉里化工蓝海物流平台积极助力上海地区复工复产",
            "href": "https://mp.weixin.qq.com/s/R_ZBj_KsSribpSd7J2Vk_Q"
        }]
    },

    //组件嘉里物流联网
    "industryDynamics": {
        "options": [{
            "label": "2022年",
            "value": "2022"
        },{
            "label": "2021年",
            "value": "2021"
        },{
            "label": "2020年",
            "value": "2020"
        }],
        "contents": [
        {
            "title": "2022-08-01",
            "content1": "嘉里物流联网加强自控货运网络服务",
            "content2": "增开由香港至美国亨茨维尔每周包机航班",
            "href": "https://www.kln.com/sc/press/press-release/2022/kerry-logistics-network-ramps-up-own-controlled-network-service-with-weekly-charter-flights-from-hong-kong-to-huntsville-usa/"
        },
        {
            "title": "2022-06-27",
            "content1": "嘉里物流联网投资者关系表现卓越",
            "content2": "连续七年荣登《机构投资者》排名榜",
            "href": "https://www.kln.com/sc/press/press-release/2022/kerry-logistics-network-s-investor-relations-excellence-reaffirmed-by-top-institutional-investor-rankings-for-the-seventh-year-running/"
        },
        {
            "title": "2022-05-11",
            "content1": "嘉里物流联网率先成为香港首家采用电动货车的物流公司",
            "content2": "迈向实现净零排放",
            "href": "https://www.kln.com/sc/press/press-release/2022/kerry-logistics-network-pioneers-as-first-logistics-company-to-use-electric-trucks-in-hong-kong-in-a-move-towards-net-zero-emissions/"
        },
        {
            "title": "2022-03-30",
            "content1": "嘉里物流联网核心纯利录得102% 增长",
            "content2": "",
            "href": "https://www.kln.com/sc/press/press-release/2022/kerry-logistics-network-posts-102-growth-in-core-net-profit/"
        },
        {
            "title": "2022-03-28",
            "content1": "嘉里物流联网蝉联杰出环球第三方物流服务供应商大奖",
            "content2": "连续七年荣获华富财经杰出企业大奖",
            "href": "https://www.kln.com/sc/press/press-release/2022/kerry-logistics-network-retains-outstanding-global-3pl-title-wins-quamnet-outstanding-enterprise-awards-for-the-seventh-consecutive-year/"
        },
        {
            "title": "2022-03-23",
            "content1": "嘉里物流联网收购康复设备供应商普康医学仪器",
            "content2": "加强在香港的医疗设备分销业务之覆盖",
            "href": "https://www.kln.com/sc/press/press-release/2022/kerry-logistics-network-acquires-rehabilitation-equipment-supplier-pro-med-technology-to-strengthen-foothold-in-medical-equipment-distribution-in-hong-kong/"
        },
        {
            "title": "2022-03-21",
            "content1": "嘉里物流联网推出「家・药配送」服务",
            "content2": "支援本地非牟利组织同渡疫情第五波",
            "href": "https://www.kln.com/sc/press/press-release/2022/kerry-pharma-supports-local-ngos-with-medication-home-delivery-during-fifth-wave-of-covid-19-outbreak-in-hong-kong/"
        },
        {
            "title": "2022-02-25",
            "content1": "嘉里物流联网荣膺",
            "content2": "2021年「港股100强」杰出物流企业奖",
            "href": "https://www.kln.com/sc/press/press-release/2022/kerry-logistics-network-named-excellent-logistics-enterprise-at-top-100-hong-kong-listed-companies-selection-2021/"
        },
        {
            "title": "2022-02-15",
            "content1": "嘉里物流联网与恒安集团之合资企业嘉利安",
            "content2": "满足香港对新冠病毒快速测试剂之殷切需求",
            "href": "https://www.kln.com/sc/press/press-release/2022/kerry-logistics-network-and-hengan-group-s-joint-venture-karrion-meets-strong-demand-for-covid-19-rapid-test-kits-in-hong-kong/"
        },
        {
            "title": "2022-01-21",
            "content1": "嘉里物流联网荣获2021年英国国际货运协会",
            "content2": "货运服务大奖空运服务奖项",
            "href": "https://www.kln.com/sc/press/press-release/2022/kerry-logistics-network-wins-air-cargo-services-award-at-the-british-international-freight-association-freight-service-awards-2021/"
        },
        {
            "title": "2021-12-17",
            "content1": "嘉里物流联网连续第五年蝉联Frost & Sullivan亚太区最佳实践奖",
            "content2": "",
            "href": "https://www.kln.com/sc/press/press-release/2021/kerry-logistics-network-wins-frost-sullivan-asia-pacific-best-practices-awards-for-the-fifth-consecutive-year/"
        },
        {
            "title": "2021-12-13",
            "content1": "嘉里物流联网荣获The Asset ESG Corporate Awards 2021及 IR Magazine大中华区奖项2021两大殊荣",
            "content2": "",
            "href": "https://www.kln.com/sc/press/press-release/2021/kerry-logistics-network-a-double-winner-of-the-asset-esg-corporate-awards-2021-and-ir-magazine-s-greater-china-awards-2021/"
        },
        {
            "title": "2021-11-16",
            "content1": "嘉里物流联网环境、社会及企业管治表现获市场认可",
            "content2": "荣膺《香港经济日报》及《彭博商业周刊/中文版》两大ESG奖项",
            "href": "https://www.kln.com/sc/press/press-release/2021/well-recognised-esg-commitment-from-kerry-logistics-network-a-proud-winner-of-hket-and-bloomberg-businessweek-esg-awards/"
        },{
            "title": "2021-11-11",
            "content1": "嘉里物流联网与 My Jet Xpress Airlines 携手",
            "content2": "推出为亚洲市场量身订制的空运服务",
            "href": "https://www.kln.com/sc/press/press-release/2021/kerry-logistics-network-and-my-jet-xpress-airlines-join-forces-to-offer-customised-air-freight-options-within-asia/"
        },{
            "title": "2021-10-22",
            "content1": "嘉里物流联网六夺亚洲货运物流及供应链奖「最佳第三方物流服务供应商」殊荣及荣获「最佳物流服务供应商－海运」奖项",
            "href": "https://www.kln.com/sc/press/press-release/2021/kerry-logistics-network-crowned-best-3pl-provider-for-the-sixth-time-and-best-logistics-service-provider-sea-at-aflas-awards/"
        },{
            "title": "2021-10-20",
            "content1": "嘉里物流联网与恒安集团成立合资企业，加强在医疗产品市场的协同竞争力",
            "href": "https://www.kln.com/sc/press/press-release/2021/kerry-logistics-network-and-hengan-group-form-joint-venture-to-enhance-synergistic-competitiveness-in-healthcare-products-market/"
        },{
            "title": "2021-10-18",
            "content1": "嘉里物流联网荣膺2021年香港管理专业协会「优质管理奖」大奖",
            "href": "https://www.kln.com/sc/press/press-release/2021/kerry-logistics-network-the-proud-recipient-of-grand-award-at-the-2021-hong-kong-management-association-quality-award/"
        },
        // ,{
        //     "title": "2021-10-14 深圳晚报",
        //     "content1": "深晚报道 | 顺丰控股收购嘉里物流 51.8% 控股权！王卫出任嘉里物流董事会主席",
        //     "href": "http://www.myzaker.com/article/616808261bc8e0f620000223"
        // },{
        //     "title": "2021-09-28 界面新闻",
        //     "content1": "顺丰完成对嘉里物流51.8%股权收购",
        //     "href": "http://www.jiemian.com/article/6651423.html"
        // },
        {
            "title": "2021-08-27",
            "content1": "嘉里物流联网核心纯利按年大升81%",
            "content2": "股东应占溢利按年增长215%",
            "href": "https://www.kln.com/sc/press/press-release/2021/kerry-logistics-network-core-net-profit-up-by-81-profit-attributable-to-the-shareholders-up-by-215/"
        },{
            "title": "2021-08-11",
            "content1": "嘉里物流联网运用KOOLBotic为食品及饮料业务冷冻产品进行分货",
            "href": "https://www.kln.com/sc/press/press-release/2021/kerry-logistics-network-utilises-koolbotic-to-sort-chilled-products-in-f-b-operation/"
        },{
            "title": "2021-08-03",
            "content1": "嘉里物流联网推出自控货运网络",
            "content2": "连接亚洲与美洲空运枢纽",
            "href": "https://www.kln.com/sc/press/press-release/2021/kerry-logistics-network-launches-own-controlled-network-to-link-asia-to-the-americas-hub/"
        },{
            "title": "2021-07-30",
            "content1": "嘉里物流联网开设秘鲁办事处以扩展拉丁美洲覆盖范围",
            "href": "https://www.kln.com/sc/press/press-release/2021/kerry-logistics-network-extends-coverage-in-latin-america-with-new-office-in-peru/"
        },{
            "title": "2021-07-02",
            "content1": "嘉里物流联网于《机构投资者》排名榜中稳居前列",
            "content2": "连续六年荣膺最受尊崇企业殊荣",
            "href": "https://www.kln.com/sc/press/press-release/2021/kerry-logistics-network-secures-places-atop-institutional-investor-rankings-recognised-as-most-honored-companies-for-the-sixth-consecutive-year/"
        },{
            "title": "2021-05-25",
            "content1": "港铁公司及嘉里物流联网携手推出「Kerry Express @ MTR Shops」新零售服务",
            "href": "https://www.kln.com/sc/press/press-release/2021/mtr-corporation-and-kerry-ecommerce-join-hands-to-launch-kerry-express-mtr-shops-new-retail-solution/"
        },{
            "title": "2021-03-25",
            "content1": "嘉里物流联网收入上升30%",
            "content2": "核心纯利增长33%",
            "href": "https://www.kln.com/sc/press/press-release/2021/kerry-logistics-network-posts-30-growth-in-revenue-core-net-profit-increased-by-33/"
        },{
            "title": "2021-02-22",
            "content1": "嘉里物流联网勇夺华富财经杰出企业大奖六连冠",
            "href": "https://www.kln.com/sc/press/press-release/2021/kerry-logistics-network-extends-winning-streak-at-the-quamnet-outstanding-enterprise-awards-for-sixth-year-running/"
        },{
            "title": "2021-02-10",
            "content1": "顺丰控股及嘉里物流联网",
            "content2": "宣布策略投资及合作",
            "href": "https://www.kln.com/sc/press/press-release/2021/s-f-holding-and-kerry-logistics-network-announce-strategic-investment-and-cooperation/"
        },{
            "title": "2021-01-15",
            "content1": "嘉里物流联网于中国沧州开设化工物流中心",
            "content2": "捕捉化工物流市场潜力",
            "href": "https://www.kln.com/sc/press/press-release/2021/kerry-logistics-network-opens-chemical-logistics-centre-in-cangzhou-china-to-capture-market-potential-in-chemical-logistics/"
        },{
            "title": "2020-12-24",
            "content1": "嘉里物流联网完成分拆附属公司",
            "content2": "Kerry Express Thailand 于泰国证券交易所首日挂牌交易",
            "href": "https://www.kln.com/sc/press/press-release/2020/kerry-logistics-network-completes-subsidiary-spin-off-kerry-express-thailand-debuts-on-the-stock-exchange-of-thailand/"
        },{
            "title": "2020-12-21",
            "content1": "嘉里物流联网荣获The Asset ESG Corporate Awards 2020",
            "content2": "翡翠奖项最高殊荣及最佳投资者关系团队奖项",
            "href": "https://www.kln.com/sc/press/press-release/2020/kerry-logistics-network-wins-the-highest-honour-the-asset-jade-award-and-the-best-investor-relations-team-award-at-the-asset-esg-corporate-awards-2020/"
        },{
            "title": "2020-12-21",
            "content1": "嘉里物流联网推出直达蒙古的新陆路货运产品",
            "content2": "提供替代方案以发掘未开发的市场潜力",
            "href": "https://www.kln.com/sc/press/press-release/2020/kerry-logistics-network-launches-new-road-freight-products-to-mongolia/"
        },{
            "title": "2020-12-16",
            "content1": "嘉里物流联网于海南自由贸易港建设50,000平方米保税物流中心",
            "content2": "把握免税及进口电子商贸市场的增长潜力",
            "href": "https://www.kln.com/sc/press/press-release/2020/kerry-logistics-network-to-develop-50-000-sq-m-bonded-logistics-centre-in-hainan-free-trade-port/"
        },{
            "title": "2020-12-15",
            "content1": "嘉里物流联网荣获香港绿色企业大奖 2020",
            "content2": "勇夺企业绿色管治奖 - 企业领导殊荣",
            "href": "https://www.kln.com/sc/press/press-release/2020/kerry-logistics-network-recognised-at-the-hong-kong-green-awards-2020/"
        },{
            "title": "2020-12-11",
            "content1": "嘉里物流联网荣获IR Magazine大中华区奖项2020",
            "content2": "勇夺「行业大奖：工业」及「最佳年报奖（中型股）」殊荣",
            "href": "https://www.kln.com/sc/press/press-release/2020/kerry-logistics-network-clinches-titles-at-ir-magazine-s-greater-china-awards-2020/"
        },{
            "title": "2020-11-10",
            "content1": "嘉里物流第五度荣获亚洲货运物流及供应链奖",
            "content2": "荣膺「最佳第三方物流服务供应商」及「最佳物流服务供应商－空运」殊荣",
            "href": "https://www.kln.com/sc/press/press-release/2020/kerry-logistics-clinches-aflas-awards-titles-for-the-fifth-time-winning-best-3pl-provider-and-best-logistics-service-provider-air-freight-honours/"
        },{
            "title": "2020-11-02",
            "content1": "嘉里物流联网连续两年荣膺《彭博商业周刊/中文版》ESG 领先企业大奖",
            "href": "https://www.kln.com/sc/press/press-release/2020/kerry-logistics-network-honoured-with-bloomberg-businessweek-esg-leading-enterprises-award-for-the-second-consecutive-year/"
        },{
            "title": "2020-09-18",
            "content1": "嘉里物流凭卓越服务荣获运输物流卓越大奖2020 - 企业大奖",
            "href": "https://www.kln.com/sc/press/press-release/2020/%E5%98%89%E9%87%8C%E7%89%A9%E6%B5%81%E5%87%AD%E5%8D%93%E8%B6%8A%E6%9C%8D%E5%8A%A1%E8%8D%A3%E8%8E%B7%E8%BF%90%E8%BE%93%E7%89%A9%E6%B5%81%E5%8D%93%E8%B6%8A%E5%A4%A7%E5%A5%962020-%E4%BC%81%E4%B8%9A%E5%A4%A7%E5%A5%96/"
        },{
            "title": "2020-08-27",
            "content1": "嘉里物流核心纯利按年上升26%",
            "content2": "国际货代业务分部溢利录得40%增长",
            "href": "https://www.kln.com/sc/press/press-release/2020/%E5%98%89%E9%87%8C%E7%89%A9%E6%B5%81%E6%A0%B8%E5%BF%83%E7%BA%AF%E5%88%A9%E6%8C%89%E5%B9%B4%E4%B8%8A%E5%8D%8726-%E5%9B%BD%E9%99%85%E8%B4%A7%E4%BB%A3%E4%B8%9A%E5%8A%A1%E5%88%86%E9%83%A8%E6%BA%A2%E5%88%A9%E5%BD%95%E5%BE%9740-%E5%A2%9E%E9%95%BF/"
        },{
            "title": "2020-08-26",
            "content1": "嘉里物流联网连续第四年荣膺Frost & Sullivan亚太区最佳实践奖",
            "href": "https://www.kln.com/sc/press/press-release/2020/%E5%98%89%E9%87%8C%E7%89%A9%E6%B5%81%E8%81%94%E7%BD%91%E8%BF%9E%E7%BB%AD%E7%AC%AC%E5%9B%9B%E5%B9%B4%E8%8D%A3%E8%86%BAfrost-sullivan%E4%BA%9A%E5%A4%AA%E5%8C%BA%E6%9C%80%E4%BD%B3%E5%AE%9E%E8%B7%B5%E5%A5%96/"
        },{
            "title": "2020-08-18",
            "content1": "嘉里物流联网旗下Kerry Apex于2020年首七个月荣登亚洲至美国第一大无船承运商",
            "href": "https://www.kln.com/sc/press/press-release/2020/%E5%98%89%E9%87%8C%E7%89%A9%E6%B5%81%E8%81%94%E7%BD%91%E6%97%97%E4%B8%8Bkerry-apex%E4%BA%8E2020%E5%B9%B4%E9%A6%96%E4%B8%83%E4%B8%AA%E6%9C%88-%E8%8D%A3%E7%99%BB%E4%BA%9A%E6%B4%B2%E8%87%B3%E7%BE%8E%E5%9B%BD%E7%AC%AC%E4%B8%80%E5%A4%A7%E6%97%A0%E8%88%B9%E6%89%BF%E8%BF%90%E5%95%86/"
        }
    ]
    },

    //组件愿景
    "vision": {
        "function": [{
            'title': "企业愿景",
            "content": "致力于成为亚洲化工物流专业翘楚。",
        },{
            'title': "企业使命",
            "content": "立足亚洲，聚焦中国，提供卓越的物流方案，为客户创利取胜。",
        },{
            'title': "企业核心价值 – VOICE",
        },{
            'title': "创造价值",
            "content": "为客户提供创新方案，为员工提供事业发展平台，为股东实现资产增值。",
        },{
            'title': "开放思想",
            "content": "提倡开放及透明化管理，鼓励坦诚沟通。"
        },{
            'title': "坚守忠诚",
            "content": "坚持诚信立业，严守道德规范。"
        },{
            'title': "竭尽所能",
            "content": "为客户信守承诺、竭尽所能，为员工及股东全心投入。"
        },{
            'title': "追求优越",
            "content": "持续改进，不断创新，追求优越。"
        }]
    },

    //组件资质荣耀
    "glory": {
        "content1": "我们长久以来致力于坚守环球服务素质。通过与客户的长期合作和持续改进，我们为客户提供最佳供应链解决方案和具有竞争力的成本管理。",
        "content2": "通过与客户的长期合作和持续改进，我们为客户提供最佳的供应链解决方案和具有竞争力的成本管理。",
        "content3": "多年来，我们赢得了专业机构的无数奖项，得到各方嘉许。未来，我们仍会不断创新改进，致力于提供更优质的服务。",
        "card": ["化学品道路运输安全评估体系", "IEC27001","IEC27001","ISO45001","ISO14001","ISO9001","巴斯夫优秀供应商","阿克苏·诺贝尔优秀供应商","珠海碧辟安全之星","江森自控优秀供应商","伊士曼优秀供应商","上纬新材料优质物流供应商","佐敦涂料杰出贡献奖","科迪华卓越贡献奖","中物联危化品物流分会副会长单位","MSDS软件著作权证书","车检软件著作权证书","NCM软件著作权证书","2020年度中国危化品物流安全管理先进企业","交通运输企业安全生产标准化建设等级证明","SEMI","中国化工物流行业“金罐奖”","2021年度化工物流运营示范科技创新项目"]
    },

    // 组件企业社会责任
    "responsibility": [
        {
            "year": "2021",
            "title": "可持续发展报告",
            "url": "https://www.kln.com/media/c1ep3mqo/esg-2021-c.pdf"
        },{
        "year": "2020",
        "title": "可持续发展报告",
        "url": "https://www.kln.com/media/bkekridc/esg-2020-c.pdf"
    },{
        "year": "2019",
        "title": "环境、社会及管治报告",
        "url": "https://www.kln.com/media/fs2jjggy/esg-2019_c.pdf"
    },{
        "year": "2018",
        "title": "环境、社会及管治报告",
        "url": "https://www.kln.com/media/r4tl5noo/esg-2018_c.pdf"
    },{
        "year": "2017",
        "title": "环境、社会及管治报告",
        "url": "https://www.kln.com/media/jbxltumi/esg-2017_c.pdf"
    },{
        "year": "2016",
        "title": "环境、社会及管治报告",
        "url": "kln.com/media/csvd4w31/esg-2016_c.pdf"
    },{
        "year": "2015",
        "title": "企业社会责任报告",
        "url": "https://www.kln.com/media/4chjaoct/esg-2015_c.pdf"
    },{
        "year": "2014",
        "title": "企业社会责任报告",
        "url": "https://www.kln.com/media/fvff4wnx/esg-2014_c.pdf"
    },{
        "year": "2013",
        "title": "企业社会责任报告",
        "url": "https://www.kln.com/media/5qultt5e/esg-2013_c.pdf"
    }],

    //组件联系我们
    "contact": {
        "title": "联系我们",
        "company": "嘉顺达化工物流有限公司",
        "address": "上海市浦东新区盛荣路388弄23号楼",
        "phone": "021-51386111",
        "post": "201210",
        "mail": "presiden.office@ims.kln.com",
        "fax": '021-51386111',
        "url": 'www.ims.kln.cn',
        "service_name":"客服电话：",
        "service_phone":"400-092-8856",
    },

    //组件合作伙伴
    "partner": {   
    },

    //组件仓储信息可视化
    "storageVisualization": {
        "content": "我们的解决方案部门会同 IT 部门，针对仓储作业进行“解构”化解，再详细的分析。具体操作过程中能够通过，流程、人员、技术的投入，来改善、改变现有的作业安全性、标准化和效率，并具备未来的复制与推广性。",
        "content2": "比如，我们在不同现场仓库，采用了 OCR 识别，RFID，Voice Picking 等不同的设备来提升效率。"    
    },
    //组件远程信息可视化
    "transportationVisualization": {
        "content": "凭借我们的数智化管理平台，无论是在中央监控室还是在客户端，都可以可实时掌握运输全过程。"
    },
    //组件msds云系统&运输车辆安全检查
    "independentlySoftware": {
        "content": "我们自主研发的HSSEQ智能管理系统软件，通过统一、共享、高效的数智化管理平台，为决策者提供及时、准确、可靠的HSSEQ信息依据。",
        "content1": "针对不同的物流作业人员，可快速随时获取MSDS文件，实现云端存储，移动终端获取，做到资料可存放可查询，即所查即所需。",
        "content2": "根据上海市车辆运管中心及道路安全协会等监察部门的规范要求，对运输车辆进行出车前，行驶中，收车后的安全检查，覆盖范围包括自有车辆以及外包车辆（到公司自有危险品仓库提货和送货车辆的安全检查），该系统采用移动终端设备检查可以记录系统时间以及检查地理位置，很大程度降低人为虚假安检的情况。",
        "content3": "应用于仓库安全巡检，分为日检、周检（仓库管理人员），检查项分为库区检查和设备类检查，采用移动终端设备检查可以记录系统时间以及检查地理位置，很大程度降低人为虚假安检的情况，提高仓库作业安全。可针对全国多仓库，包括库区检查和设备检查，同时涵盖危险品车辆进入园区的安全检查。",
        "content4": "根据《GB 13861生产过程危险和有害因素分类与代码》进行原因分析，针对企业中日常运营过程中的不符合项的管理，包括不符合项的记录、分析、跟踪、发布等，有助于帮助识别根本原因的查找并避免未来同样的事件重复发生。便于事件相关者及管理人员对事故事件的科学分析，从而客观、准确的分析事故事件产生的最终原因，从而有针对性的制定防范措施。",
        "content5": "目前我司系统已与多家客户实现EDI对接, 可实现订单对接、客户档案、产品档案、入库、出库、移库、库存差异报告功能。"
    },
    //组件工作机会
    "workChance": {
        "content": "我们深信员工是企业的重要资产，诚邀您加入我们的团队，请点击下方查看详情。",
        "title1": "工作内容:", 
        "title2": "任职要求:",
        "title3": "工作地点:",
        "title4": "简历请投递至:",
        "positionList": [{
            "position": "电子化学品物流经理",
            "jobContent": ['根据公司战略目标，完成公司计划制定对客户需求收集成本并能制作方案;','熟悉危险品操作流程、国内运输、仓储或进出口空海运;','负责开拓电子化学品客户，日常客户关系维护;','调查、跟踪、分析客户需求，及时有效地提供客户服务;','跟进客户合同谈判、签署，公司内部审核流程;','负责项目的应收应付账款的正常回收支付。'],
            "jobRequirement": ['5年以上相关工作经验，具有一定供应链项目经验，大专以上学历','有半导体原物料物流行业经验，有半导体、电子化学品物流经验或者客户','良好的沟通协调能力、组织计划能力、学习应用能力及适应环境能力','熟练运用办公软件，擅长PPT制作及Excel数据分析。'],
            "workAddress": "上海市浦东新区盛荣路388弄23号",
            "mail": "hr.dept@kerryims.com"
        },{
            "position": "物流销售经理",
            "jobContent": ['负责公司化工物流业务的市场拓展和项目开发工作;','负责对当地及周边地区的化工企业、化工园区的市场调研和物流需求分析，并建立与园区、企业之间的沟通合作关系;','负责获取并参与化工客户的物流招标活动及标书准备工作;','负责根据客户要求制作业务报价和完成合同流程;','负责收集和分析当地竞争对手的信息和动态;','负责了解所在地区的化工专业操作资源信息;','完成公司规定的销售工作报告、报表及系统操作等内部管理工作。'],
            "jobRequirement": ['有1年以上国内物流行业销售经验，有强烈的客户开发和销售意向;','有化工物流行业销售经验优先考虑;','具有较强的开拓与沟通能力，能承受压力，品行端正。'],
            "workAddress": "上海市浦东新区盛荣路388弄23号",
            "mail": "hr.dept@kerryims.com"
        },{
            "position": "仓库经理",
            "jobContent": ['处理项目仓储运营管理与咨询项目的日常运营，包括货物的进货，出货，储存，退货，盘点，订单处理，客户服务，仓库管理和配送管理系统的运营;','确保该项目严格按照标准运营流程（SOP）和质量标准（KPI）高效运营;','带领团队，对该项目实施PDCA改进计划，不断提高运营效率，降低运营成本;','负责该项目的人员和团队建设和管理;','安全管理：确保该项目的货物，人员，财产，信息和公司形象的安全;','客户管理：确保客户的满意度达到99%。'],
            "jobRequirement": ['有丰富的仓储管理经验，熟练掌握仓库和配送管理系统;','极强的团队管理和现场作业管理能力;','有一定的文字和PPT功底。'],
            "workAddress": "上海市浦东新区盛荣路388弄23号",
            "mail": "hr.dept@kerryims.com"
        },{
            "position": "仓储管培生",
            "jobContent": ['文档的整理、书写;','相关仓库现场清点、数据分析;','物流相关系统操作;','编写PPT报告、提交月度实习报告;','日常会议纪要记录。'],
            "jobRequirement": ['有很强的表达能力和学习能力，愿意接受外派及出差。'],
            "workAddress": "上海市浦东新区盛荣路388弄23号",
            "mail": "hr.dept@kerryims.com"
        },{
            "position": "财务主管",
            "jobContent": ['了解公司财务管理，包括预算管理、核算管理等;','负责加强公司资金管理，保证企业运营所需资金的正常运转;','对公司税收进行整体筹划，加强公司经济管理，提高经济效益;','建立健全公司财务管理、会计核算、预算等相关制度，保障公司合法经营，维护公司权益;','负责统筹组织公司财务预算、会计核算、财务报告等，定期检查、监督、跟进预算执行的情况，及时做出调整与控制;','了解公司财务状况、经营成果和资金变动情况，及时提供真实的会计核算资料，组织经营分析报告，为公司决策提供依据。'],
            "jobRequirement": ['5年以上财务工作经验，其中3年以上总账会计经验;','具备初级会计职称;','熟悉各种财务系统及软件。'],
            "workAddress": "上海市浦东新区盛荣路388弄23号",
            "mail": "hr.dept@kerryims.com"
        }]
    }
}

export default zh;



// WEBPACK FOOTER //
// ./src/assets/languages/zh.js